import api from '@/api/api'

const decodeToken = (token) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(window.atob(base64))
}

const auth = {
  loggedIn() {
    return Boolean(localStorage.token)
  },
  isAdmin() {
    return localStorage.permissions && localStorage.permissions.includes('ROLE_ADMINISTRATIVE_VALIDATION')
  },
  getAuthorities() {
    return localStorage.permissions && localStorage.permissions.split(',')
  },
  getName() {
    return localStorage.name
  },
  logIn(username, password) {
    return api.authenticate(username, password).then(token => {
      const userData = decodeToken(token)

      localStorage.token = token
      localStorage.permissions = userData.auth.split(',')
      localStorage.expires = userData.exp
    }).then(() => {
      api.appUser.currentUser().then(response => {
        localStorage.name = response.data.name
        this.updateSession()
      })
    })
  },
  logOut() {
    localStorage.removeItem('token')
    localStorage.removeItem('permissions')
    localStorage.removeItem('expires')
    localStorage.removeItem('name')

    this.updateSession()
  },
  updateSession() {
    this.session.loggedIn = this.loggedIn()
    this.session.isAdmin = this.isAdmin()
    this.session.authorities = this.getAuthorities()
    this.session.name = this.getName()
  }
}

const session = {} // This is used as a reactive object for vue components
auth.session = session
auth.updateSession()

export {session, auth}
export default auth



// WEBPACK FOOTER //
// ./src/auth.js